import { apiFetch } from '../api/client'
import { getStoredConsent, type ConsentState } from '../../components/CookieBanner'

const SESSION_KEY = 'fukodrom_analytics_session'

function getSessionId() {
  if (typeof window === 'undefined') return ''
  const existing = window.sessionStorage.getItem(SESSION_KEY)
  if (existing) return existing
  const created = window.crypto?.randomUUID?.() ?? `session-${Date.now()}`
  window.sessionStorage.setItem(SESSION_KEY, created)
  return created
}

export function getConsentState(): ConsentState | null {
  return getStoredConsent()
}

export async function trackEvent(eventName: string, payload: Record<string, unknown> = {}) {
  const consent = getConsentState()
  if (consent !== 'accepted') return

  try {
    await apiFetch('/analytics/events', {
      method: 'POST',
      body: JSON.stringify({
        event_name: eventName,
        session_id: getSessionId(),
        consent: 'analytics',
        payload,
      }),
    })
  } catch {
    // analytics must never break product UX
  }
}
